/*=========================================================================================
  File Name: moduleCountryActions.js
  Description: Country Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from "@/axios.js" 
import { erpApi } from "@/axios.js" 

export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("api/Property/Add", item
  //       , {headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
  //     )
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
addItem({ commit }, item) {
  return new Promise((resolve, reject) => {
    
    axios.post("api/Property/Add", item, {
      headers: { Authorization: 'Bearer ' + localStorage.accessToken }
    })
    .then((response) => {
    
      const resData = response.data.Data; 

      if (resData) {
       
        commit('ADD_ITEM', Object.assign(item, { ID: resData.Id }));
        resolve(response);
        
        const erpPayload = {
          PropertyCode: resData.PropertyCode,
          PropertyNameAr: resData.PropertyNameAr,
          PropertyNameEn: resData.PropertyNameEn
        };

             
        erpApi.post("api/erp/integration/create-property-account", erpPayload)
          .then((erpResponse) => {
            console.log("تمت المزامنة مع الـ ERP بنجاح:", erpResponse.data);
            resolve(response);
          })
          .catch((erpError) => {
            console.error("فشلت المزامنة مع الـ ERP ولكن تم الحفظ في رقمنة:", erpError);
            resolve(response); 
          });
      } else {
        console.error("Failed to add item. Response data :", response.data);
        resolve(response);
      }
    })
    .catch((error) => { 
      reject(error); 
    });
  });
},
  fetchDataListItems({ commit }) {
    return new Promise((resolve, reject) => {

      axios.get("api/Property/GetAll"
        , {headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
      )
        .then((response) => {

          commit('SET_Properties', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


   fetchPropertyListingStatus({ commit }) {
      return new Promise((resolve, reject) => {

        // TODO: Implement the code for retrieving all purchase order status
        axios.get("api/PropertyListingStatus/GetAll"
          , {headers: { Authorization: 'bearer ' + localStorage.accessToken,}}
          , {headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
        )
          .then((response) => {

            commit('SET_PropertyListingStatus', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },



  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {

      axios.put("API/Property/Update", item
        ,{headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
      )
        .then(response => {

          commit('UPDATE_Properties', item);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },


GetItemByID({ commit }, itemid) {

  return new Promise((resolve, reject) => {

    axios.get(`API/Property/GetById/${itemid}`, {
      headers: { Authorization: 'Bearer ' + localStorage.accessToken }
    })
    .then((response) => {

      commit('GET_ITEM_BY_ID', response.data.Data);
      resolve(response);
    })
    .catch((error) => { reject(error) });
  });
},

  removeItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete(`API/Property/Delete/${item.Id}`, {
        headers: { Authorization: 'Bearer ' + localStorage.accessToken }
      })
        .then((response) => {
          commit('REMOVE_ITEM', item.id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  fetchFilteredProperties({ commit }, filters) {
    return axios.post("/api/Property/Search", filters)
      .then((response) => {
commit("SET_Properties", response.data);
        //commit("SET_Properties", response.data.Data);
      })
      .catch((error) => { console.error(error); });
  },
  fetchPropertyImages({ commit }, propertyId) {
      return new Promise((resolve, reject) => {
        axios.get(`api/PropertyImage/GetByPropertyId/${propertyId}`)
          .then((response) => {
            commit('SET_PROPERTY_IMAGES', response.data.Data);
            resolve(response);
          })
          .catch((error) => { reject(error); });
      });
    },

    addPropertyImage({ commit }, imageData) {
      return new Promise((resolve, reject) => {

        axios.post('api/PropertyImage/Add', imageData)
          .then((response) => {
            commit('ADD_IMAGE_TO_LIST', response.data.Data);
            resolve(response);
          })
          .catch((error) => { reject(error); });
      });
    },
updatePropertyImage({ commit }, imageData) {
  return new Promise((resolve, reject) => {
    axios.put('api/PropertyImage/Update', imageData)
      .then((response) => {
        commit('UPDATE_IMAGE_IN_LIST', response.data.Data);
        resolve(response);
      })
      .catch((error) => { reject(error); });
  });
},
deletePropertyImage({ commit }, imageId) {
  return new Promise((resolve, reject) => {

    axios.delete(`api/PropertyImage/Delete/${imageId}`)
      .then((response) => {
        commit('REMOVE_IMAGE_FROM_LIST', imageId);
        resolve(response);
      })
      .catch((error) => { reject(error); });
  });
},
// Document Actions
  fetchPropertyDocuments({ commit }, propertyId) {
    return axios.get(`/api/PropertyDocument/GetByPropertyId/${propertyId}`)
      .then(res => commit('SET_PROPERTY_DOCUMENTS', res.data.Data));
  },
  addDocument({ commit }, docItem) {
    return axios.post("/api/PropertyDocument/Add", docItem)
      .then(res => {
        commit('ADD_PROPERTY_DOCUMENT', res.data.Data);
        return res;
      });
  },
  updateDocument({ commit }, docItem) {
    return axios.put("/api/PropertyDocument/Update", docItem)
      .then(res => {
        commit('UPDATE_PROPERTY_DOCUMENT', res.data.Data);
        return res;
      });
  },
  deleteDocument({ commit }, id) {
    return axios.delete(`/api/PropertyDocument/Delete/${id}`)
      .then(() => commit('REMOVE_PROPERTY_DOCUMENT', id));
  },
  fetchPropertyRentalData({ commit }, propertyId) {
  return new Promise((resolve, reject) => {
    axios.get(`api/PropertyRentalData/GetByPropertyId/${propertyId}`, {
      headers: { Authorization: 'Bearer ' + localStorage.accessToken }
    })
    .then((response) => {
      commit('SET_PROPERTY_RENTAL_DATA', response.data.Data);
      resolve(response);
    })
    .catch((error) => { reject(error); });
  });
},
updatePropertyRentalData({ commit }, payload) {
  return new Promise((resolve, reject) => {
    const method = (payload.Id && payload.Id > 0) ? 'put' : 'post';
    const url = (payload.Id && payload.Id > 0) ? 'api/PropertyRentalData/Update' : 'api/PropertyRentalData/Add';

    axios[method](url, payload, {
      headers: { Authorization: 'Bearer ' + localStorage.accessToken }
    })
    .then((response) => {
      commit('SET_PROPERTY_RENTAL_DATA', response.data.Data);
      resolve(response);
    })
    .catch((error) => { reject(error); });
  });
},
 uploadImage(_, file) {
    return new Promise((resolve, reject) => {

      const formData = new FormData();
      formData.append("file", file);

      axios.post("/api/Common/UploadImage", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });

    });
  },
}
